import React from 'react';
import OrderForm from './OrderForm';
import styles from '../styles/PlaceOrder.module.css';

const PlaceOrder = ({ onSubmit, isSubmitting, error }) => (
  <section className={styles.section} aria-labelledby="place-order-title">
    <div className={styles.heading}>
      <p className={styles.label}>Place order</p>
      <h2 id="place-order-title">Your order details</h2>
      <p>Tell us how to prepare your order before secure payment.</p>
    </div>
    <OrderForm onSubmit={onSubmit} isSubmitting={isSubmitting} error={error} />
  </section>
);

PlaceOrder.defaultProps = {
  onSubmit: () => {},
  isSubmitting: false,
  error: '',
};

export default PlaceOrder;
